import { Scheduler as ScheduleBarChart } from "../../containers";
import { ScheduleTable } from "../../tables";
import Scheduler from "./Scheduler";
import Throughput from "./Throughput";
import DailyThroughput from "../../containers/DailyThroughput/DailyThroughput";

export { GRAPH_TAB, MAX_CHART_WEEKS } from "./constants";

export const sidetabs = [
  {
    id: 1,
    label: "Scheduler",
    icon: "Calendar",
    Component: Scheduler,
  },
  {
    id: 2,
    label: "Throughput",
    icon: "DollarSign",
    Component: Throughput,
  },
  {
    id: 3,
    label: "Daily",
    icon: "BarChart2",
    Component: DailyThroughput,
  },
];

export const tabs = [
  {
    id: 1,
    label: "Graph",
    icon: "BarChart2",
    container: ScheduleBarChart,
  },
  {
    id: 2,
    label: "Timeline",
    icon: "BarChart2",
    container: ScheduleTable,
  },
];

export const getContainer = (id) => {
  const tab = tabs.find((t) => t.id === id) || tabs[0];
  return tab.container;
};
